import React from 'react'
import {Icon} from '@chakra-ui/react'

const GalleryBucketInTheBoxIcon = (props) => {
    return (
        <Icon viewBox="0 0 14 14" fill="none" {...props}>
            <path
                opacity="0.1"
                d="M7 7.83337V3.58337"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7 11.8333V7.58331"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.84954 1.28917C8.99483 1.20793 9.15851 1.16528 9.32496 1.16528C9.49142 1.16528 9.65509 1.20793 9.80038 1.28917L12.2504 2.66583C12.4239 2.76395 12.5682 2.90638 12.6687 3.07856C12.7691 3.25074 12.822 3.4465 12.822 3.64583C12.822 3.84517 12.7691 4.04093 12.6687 4.21311C12.5682 4.38529 12.4239 4.52772 12.2504 4.62583L5.14538 8.6275C4.99966 8.71062 4.8348 8.75433 4.66704 8.75433C4.49929 8.75433 4.33443 8.71062 4.18871 8.6275L1.75038 7.25083C1.57686 7.15272 1.43251 7.01029 1.33207 6.83811C1.23163 6.66593 1.17871 6.47017 1.17871 6.27083C1.17871 6.0715 1.23163 5.87574 1.33207 5.70356C1.43251 5.53138 1.57686 5.38895 1.75038 5.29083L8.84954 1.28917Z"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.6663 7.58331V9.84081C11.6666 10.061 11.6063 10.277 11.4921 10.4653C11.3779 10.6535 11.2142 10.8068 11.0188 10.9083L7.51884 12.705C7.35848 12.7883 7.1804 12.8318 6.99967 12.8318C6.81895 12.8318 6.64087 12.7883 6.48051 12.705L2.98051 10.9083C2.78514 10.8068 2.62143 10.6535 2.50724 10.4653C2.39305 10.277 2.33278 10.061 2.33301 9.84081V7.58331"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.2504 7.25085C12.4239 7.15273 12.5682 7.01031 12.6687 6.83813C12.7691 6.66595 12.822 6.47019 12.822 6.27085C12.822 6.07152 12.7691 5.87576 12.6687 5.70358C12.5682 5.5314 12.4239 5.38897 12.2504 5.29085L5.15121 1.28335C5.00648 1.20047 4.84258 1.15686 4.67579 1.15686C4.50901 1.15686 4.34511 1.20047 4.20038 1.28335L1.75038 2.66585C1.57686 2.76397 1.43251 2.9064 1.33207 3.07858C1.23163 3.25076 1.17871 3.44652 1.17871 3.64585C1.17871 3.84519 1.23163 4.04095 1.33207 4.21313C1.43251 4.38531 1.57686 4.52773 1.75038 4.62585L8.85538 8.62752C9.00004 8.71063 9.16396 8.75437 9.3308 8.75437C9.49763 8.75437 9.66155 8.71063 9.80621 8.62752L12.2504 7.25085Z"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </Icon>
    )
}

export default GalleryBucketInTheBoxIcon
